(function (angular) {
  "use strict";

  angular.module('myApp').component('qrCode', {
    templateUrl: '/home/views/qr-code.tpl.html',
    controller: [
      '$scope',
      function ($scope) {

        $scope.isApproved = localStorage.getItem("isApproved");
        $scope.qrCodeUrl = localStorage.getItem("qrCodeUrl");

        $scope.downloadQrCode = function () {
          if ($scope.qrCodeUrl != 'null') {
              window.open($scope.qrCodeUrl);
          }
        }
      }
    ]
  });

}(window.angular));
